import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';
import { Button } from '../button';
import { Flex } from '../flex';
import {BodyText, Span} from '../typography';

export const StyledBody = styled(BodyText)`
  color: ${({theme}) => theme.colors.primaryK7};
  max-width: 50rem;
  & > {
    font-size: var(--main-font-size);
  }
`;

export const StyledBoldBody = styled(Span)`
  color: ${({theme}) => theme.colors.primaryK7};
  max-width: 50rem;
  & > {
    font-size: var(--main-font-size);
  }
  font-weight: ${({theme}) => theme.fontWeight.bold};
`;

export const StyledSubtitle = styled(BodyText)`
  color: ${({theme}) => theme.colors.primaryK7};
  margin-top: 0.25rem;
`;

export const StyledPageWithHeader = styled(Flex)`
  margin-top: 2.844rem;
  ${StyledBody} {
    color: ${({theme}) => theme.colors.primaryK7};
  }
`;

export const ContentContainer = styled.div`
  width: 100%;
  margin-top: 3.025rem;
  margin-bottom: 8.438rem;

  ${mediaQuery('md')} {
    margin-top: 3.063rem;
    margin-bottom: 5rem;
  }
`;

export const PageText = styled(BodyText)`
  color: ${({theme}) => theme.colors.primaryK7};
  padding-bottom: 1.563rem;
  max-width: 100%;

  ${mediaQuery('md')} {
    width: 34.5rem;
  }
`;

export const StyledBackButton = styled(Button)`
  margin-bottom: 1.906rem;
`;
